import { apiRequest } from "../util/apiUtils";

const isFormData = (val) => {
  return typeof FormData !== "undefined" && val instanceof FormData;
};

const normalizeCreateChatPayload = (payload) => {
  if (!payload || typeof payload !== "object") return payload;

  if (isFormData(payload)) {
    const recipientType = payload.get("recipientType");
    const inboxType = payload.get("inboxType");

    // Validation rules from backend:
    // - If recipientType="company" then inboxType must be "company"
    // - If inboxType="company" AND recipientType="user" then companyId is REQUIRED.
    // - Don't send companyId with inboxType="personal".
    if (recipientType === "company") {
      payload.set("inboxType", "company");
    }

    const nextInboxType = payload.get("inboxType") || inboxType;
    if (nextInboxType === "personal") {
      payload.delete("companyId");
    }

    if (nextInboxType === "company" && recipientType === "user") {
      const companyId = payload.get("companyId");
      if (!companyId) {
        throw new Error(
          'Validation error: "companyId" is required when inboxType="company" and recipientType="user".',
        );
      }
    }

    return payload;
  }

  const normalized = { ...payload };

  // Validation rules from backend:
  // - If inboxType="company" AND recipientType="user" then companyId is REQUIRED.
  // - Don't send companyId with inboxType="personal".
  if (normalized.recipientType === "company") {
    normalized.inboxType = "company";
  }

  if (normalized.inboxType === "personal") {
    delete normalized.companyId;
  }

  if (
    normalized.inboxType === "company" &&
    normalized.recipientType === "user"
  ) {
    if (!normalized.companyId) {
      throw new Error(
        'Validation error: "companyId" is required when inboxType="company" and recipientType="user".',
      );
    }
  }

  return normalized;
};

export const communicationList = async (params) => {
  try {
    const res = await apiRequest("get", `/communication-group/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const communicationChatList = async (params) => {
  try {
    const res = await apiRequest("get", `/communication/chat-list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
export const CreateChat = async (payload) => {
  const multipart = isFormData(payload);
  const contentType = multipart ? "multipart/form-data" : "application/json";
  const normalized = normalizeCreateChatPayload(payload);

  const res = await apiRequest(
    "post",
    `communication/create-chat`,
    {
      body: normalized,
    },
    contentType,
  );

  const data = res?.data;
  if (data?.status && data.status !== 200) {
    // Make react-query treat non-200 API payload statuses as errors
    const err = new Error(data?.message || "Failed to send message.");
    err.data = data;
    throw err;
  }

  return data;
};

export const communicationSeen = async (payload) => {
  const res = await apiRequest("patch", `communication/seen`, {
    body: payload,
  });

  const data = res?.data;
  if (data?.status && data.status !== 200) {
    const err = new Error(data?.message || "Failed to mark seen.");
    err.data = data;
    throw err;
  }

  return data;
};

export const communicationDelete = async (payload) => {
  try {
    const res = await apiRequest("delete", `communication/delete`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const communicationStatusChange = async (payload) => {
  try {
    const res = await apiRequest("patch", `communication/status`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const notificationList = async (params) => {
  try {
    const res = await apiRequest("get", `notification/backend/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
export const backendSeen = async (payload) => {
  try {
    const res = await apiRequest("post", `notification/backend/seen`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    return err;
  }
};

export const msgUnreadList = async (params) => {
  try {
    const res = await apiRequest("get", `communication/unreade-list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
